import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=6527a766&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=6527a766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6527a766",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6527a766')) {
      api.createRecord('6527a766', component.options)
    } else {
      api.reload('6527a766', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=6527a766&scoped=true&", function () {
      api.rerender('6527a766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Layout/Loader.vue"
export default component.exports